import { render, staticRenderFns } from "./MaintenanceRecord.vue?vue&type=template&id=2b4cc7c8"
import script from "./MaintenanceRecord.vue?vue&type=script&lang=js"
export * from "./MaintenanceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports